import { render, staticRenderFns } from "./DocsShowCode.vue?vue&type=template&id=49656503&scoped=true&"
import script from "./DocsShowCode.vue?vue&type=script&lang=js&"
export * from "./DocsShowCode.vue?vue&type=script&lang=js&"
import style0 from "./DocsShowCode.vue?vue&type=style&index=0&id=49656503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49656503",
  null
  
)

export default component.exports